var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',{staticClass:"capacity__cell"},[_vm._v("\n        "+_vm._s(_vm.row.location.name)+"\n    ")]),_vm._v(" "),_vm._l((_vm.row.cells),function(cell){return _c('td',{staticClass:"capacity__cell"},[_c('publication-capacity-cell',{attrs:{"cell":cell}})],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }